import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-app_icon-23",
  "use": "icon-app_icon-23-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-app_icon-23\"><g><path d=\"M14.47 3.117L24 8.19v21.677H4V8.19l9.53-5.073a1 1 0 01.94 0zm4.03 16.75h-9a1.5 1.5 0 100 3h9a1.5 1.5 0 000-3zm0-7h-9a1.5 1.5 0 100 3h9a1.5 1.5 0 000-3z\" /><rect x=\"1\" y=\"29.856\" width=\"34\" height=\"3\" rx=\"1.5\" /><path d=\"M22 17.021l4.466-2.817a1 1 0 011.068 0L32 17.02v12.846H22V17.021z\" fill-opacity=\".6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol